import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { ImageUrl } from '../../../../../Helpers/request'
import { LazyLoadImage } from "react-lazy-load-image-component";
const itemsData = [
  { title: "Engagement Rings", link: "/engagement-rings", img: `${ImageUrl}theme/paris/engagement_ring.jpg` },
  { title: "Wedding Rings", link: "/jewelry/wedding-rings", img: `${ImageUrl}theme/paris/wedding_ring.jpg` },
  { title: "Fine Jewelry", link: "/jewelry/fine-jewelry", img: `${ImageUrl}theme/paris/fine_jewelry.jpg` },
];

const YourPleasure = () => {
  return (
    <div className='pleasure_bx'>
        <Container>
            <Row> 
                <Col md={12}>
                    <div className="main_heading">
                        <h2>What’s Your Pleasure? </h2>
                    </div>
                </Col>
            </Row>

            <Row>
                {itemsData.map((item, index) => (
                  <Item key={index} title={item.title} link={item.link} img={item.img} />
                ))}
            </Row>
        </Container>
    </div>
  )
}

const Item = ({title, link, img}) => {
    return <Col lg={4} md={12}>
        <div className="pb_inner">
            <Link to={link}>
                <LazyLoadImage src={img} alt="" />
                <div className="p_title">{title}</div>
            </Link>
        </div>
    </Col>
}

export default YourPleasure